var map = {
	"./drag_l.webp": 5480,
	"./lambert_l.webp": 165,
	"./lambert_long_l.webp": 9990,
	"./language/a1_l.webp": 3717,
	"./language/a2_l.webp": 4780,
	"./language/a3_l.webp": 343,
	"./language/b1_l.webp": 1062,
	"./language/b2_l.webp": 9211,
	"./language/b3_l.webp": 4544,
	"./language/c1_l.webp": 9679,
	"./language_l.webp": 6592,
	"./newonce/a1_l.webp": 9372,
	"./newonce/a2_l.webp": 8309,
	"./newonce/b1_l.webp": 1519,
	"./newonce/b2_l.webp": 2186,
	"./newonce_l.webp": 9235,
	"./punk_l.webp": 5782,
	"./sso_l.webp": 5071
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2562;